import { SafeSuspense } from '@calendly/safe-suspense'
import { lazy } from 'react'

import LoadingState from 'components/core/loading_state'

const loadChunk = async () => {
  const loaded = await import(/* webpackChunkName: 'userGroupManagement' */'./management')
  return { default: loaded.Management }
}

const Management = lazy(loadChunk)

export const Page = () => (
  <SafeSuspense fallback={<LoadingState />}>
    <Management />
  </SafeSuspense>
)
